export const useStyles = (theme) => ({
  gridRoot: { padding: 10 },
  paper: {
    padding: 10,
    "&:hover": { cursor: "pointer" },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 16,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  tooltip: { "&:hover": { cursor: "pointer" } },
});
